import React, { useState, useEffect } from "react";
import UISectionHeading from "../Common/UISectionHeading/UISectionHeading";
import UiButton from "../Common/UiButton/UiButton";
import { Col, Row } from "react-bootstrap";
import { Form, message, Checkbox } from "antd";
import TextInput from "../Common/UITextInput/TextInput";
import "../EngagementDetails/EngagementDetails.css";
import VerificationIc from "../../images/Verified-Partner.png";
import { LoadingOutlined } from "@ant-design/icons";
import { saveTeamsAadharDetails } from "../../redux/TeamsAadherVerification/action";
import { getTeamsAadharDetailAll } from "../../redux/TeamDetailsMaster/action";
import { Spin, notification } from "antd";
import { connect } from "react-redux";
import useSession from "../CustomLogout/useSession";

const TeamAadharVerification = (props) => {
  const handleSessionExpired = useSession();

  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const Id = sessionStorage.getItem("cetFirmId");

  const [partnerFirmMSMEFlagCheck, setPartnerFirmMSMEFlagCheck] =
    useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [panNotext, setpanNotext] = useState("");
  const [showText, setShowText] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [showEditBtn, setShowEditBtn] = useState(false);

  const { saveAllIndication, setHandleGetTeamAadhar } = props;

  useEffect(() => {
    if (saveAllIndication) {
      form.submit();
    }
  }, [saveAllIndication]);

  const toggle = () => {
    setDisabled(false);
    setBtnDisable(false);
  };

  useEffect(() => {
    if (props.personId == undefined) {
      setPartnerFirmMSMEFlagCheck(false);
      setpanNotext("");
      setShowText(false);
      setBtnDisable(false);
      setDisabled(false);
      setShowEditBtn(false);
      form.setFieldsValue({
        partnerTeamAadhaarNumber: "",
      });
    }
    if (props.data && props.personId !== undefined) {
      const getAllAadharTeamsDetails =
        props.data?.teamsAadharDataList?.dto ?? "";

      setpanNotext(getAllAadharTeamsDetails?.partnerTeamAadhaarNumber);
      setPartnerFirmMSMEFlagCheck(
        getAllAadharTeamsDetails?.partnerTeamAadhaarConsent
      );
    }

    form.setFieldsValue({
      partnerTeamAadhaarNumber:
        props.data?.teamsAadharDataList?.dto?.partnerTeamAadhaarNumber,
    });

    if (
      props.data?.teamsAadharDataList?.dto?.partnerTeamAadhaarConsent &&
      props?.personId !== undefined
    ) {
      setShowText(true);
      setDisabled(true);
      setShowEditBtn(true);
    }

    if (!props.data?.teamsAadharDataList?.dto?.partnerTeamAadhaarConsent) {
      setShowText(false);
      setDisabled(false);
      setShowEditBtn(false);
    }
  }, [props.data, props?.personId]);

  const onChangeTextHandler = (event) => {
    const result = event.target.value.toUpperCase();
    setpanNotext(result);
  };

  const onClickChange = (data) => {
    const AadharTeamsVerificationData = {
      partnerPersonId: props.personId,
      partnerTeamAadhaarNumber: panNotext,
      partnerTeamAadhaarConsent: partnerFirmMSMEFlagCheck,
    };

    if (saveAllIndication) {
      setHandleGetTeamAadhar(AadharTeamsVerificationData);
    } else {
      setSaveLoading(true);
      props
        .saveTeamsAadharDetails({
          values: AadharTeamsVerificationData,
          access_token: props.access_token,
        })
        .then((res) => {
          setSaveLoading(false);
          if (res && res.status === 200) {
            message.success("Saved", 2);
            setShowText(true);
            setDisabled(true);
            setTimeout(() => {
              setShowEditBtn(true);
            }, 3000);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              setSaveLoading(false);

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((e) => {
          setSaveLoading(false);
        });
    }
  };
  const handlEditChanges = () => {
    setPartnerFirmMSMEFlagCheck(false);
    setBtnDisable(false);
    setShowText(false);
    setDisabled(false);
    setShowEditBtn(false);
  };
  return (
    <div>
      <Form
        autoComplete="off"
        name="teamAadharVerification"
        form={form}
        onFinish={onClickChange}
      >
        <div className="inner-content">
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={6} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="Aadhar Verification" />
                </div>
              </Col>
              <Col md={6} className="right-field-section">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col
                      md={6}
                      className="Mobile-sec pan-mob"
                      style={{ width: "40%" }}
                    >
                      {/* <FormItem name="partnerTeamAadhaarNumber" colon={false}> */}
                      <TextInput
                        title="Aadhaar Number"
                        name="partnerTeamAadhaarNumber"
                        defaultValue={panNotext}
                        onChange={onChangeTextHandler}
                        value={panNotext}
                        type="number"
                        validation={[
                          {
                            required: false,
                            message: "Aadhar number Required",
                          },

                          {
                            pattern: new RegExp("^[0-9,A-Z]{12}$"),
                            message: "Invalid Aadhar Number",
                          },
                        ]}
                      />
                      {/* </FormItem> */}

                      {/* <TextInput
                        name="partnerTeamAadhaarNumber"
                        defaultValue={panNotext}
                        onChange={onChangeTextHandler}
                        value={panNotext}
                        type="number"
                        validation={[
                          {
                            required: true,
                            message: "Aadhar number Required",
                          },

                          {
                            pattern: new RegExp("^[0-9,A-Z]{12}$"),
                            message: "Invalid Aadhar Number",
                          },
                        ]}
                      /> */}
                    </Col>
                    <Col md={6} className="btn-verify">
                      <div className="verfication-opt-btn">
                        {showText ? (
                          <img
                            className="verifi-ic-btn"
                            src={VerificationIc}
                            alt=""
                          />
                        ) : (
                          <UiButton
                            disabled={btnDisable || panNotext === ""}
                            type="submit"
                            title="Verify"
                            // onClick={onClickChange}
                          />
                        )}

                        {saveLoading && (
                          <div className="pr-4 spanner">
                            <Spin
                              size="large"
                              className="pr-4"
                              indicator={
                                <LoadingOutlined style={{ color: "#00d8db" }} />
                              }
                            ></Spin>
                          </div>
                        )}
                        {showEditBtn ? (
                          <div className="btn-edit-sec">
                            <UiButton
                              type="save"
                              title="Change/Edit"
                              onClick={handlEditChanges}
                            />
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={6} className="check-sec-1 pan-ver">
                      <FormItem
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "",
                          },
                        ]}
                      >
                        <Checkbox
                          value={partnerFirmMSMEFlagCheck}
                          checked={partnerFirmMSMEFlagCheck}
                          disabled={disabled}
                          name="partnerTeamAadhaarConsent"
                          onClick={toggle}
                          onChange={() =>
                            setPartnerFirmMSMEFlagCheck(
                              !partnerFirmMSMEFlagCheck
                            )
                          }
                        >
                          <p className="text-left">
                            By clicking on the checkbox, you provide express
                            consent and authorization, voluntarily,to Avanse
                            Financial Services Limited to
                            <br />
                            (i) Retrieve your Aadhaar information through a
                            third party services provider Karza.
                            <br />
                            (ii) Use this information for identification,
                            verification and due-diligence purposes.
                          </p>
                        </Checkbox>
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <div className="pan-last-sec"></div>
          <hr></hr>
        </div>
      </Form>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveTeamsAadharDetails: (data) => dispatch(saveTeamsAadharDetails(data)),
    getData: (accessToken) => dispatch(getTeamsAadharDetailAll(accessToken)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    data: state.teamsMasterData,
    partnerPersonId: state.saveDirectorDetails.partnerPersonID,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamAadharVerification);
